import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ISalesList } from "../../../Pages/Sales/ISales";

export const SalesSlicer = createSlice({
  name: "Subscription",
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<ISalesList[]>,
  reducers: {
    getSubscription: (state, _) => {
      state.isLoading = true;
    },
    successGetSubscription: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureGetSubscription: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
  },
});

export const { getSubscription, failureGetSubscription, successGetSubscription } =
  SalesSlicer.actions;

export default SalesSlicer.reducer;
